import { Injectable, NgZone, inject } from '@angular/core';

import { SessionEndService } from './session-end.service';

/**
 * Ends this app's session when another app signs the user out, which it marks with a `logoutEvent` cookie on the
 * shared domain. The poll runs outside Angular's zone so it does not trigger change detection every 3 seconds.
 */
@Injectable({ providedIn: 'root' })
export class LogoutEventWatcherService {
  private zone = inject(NgZone);
  private sessionEnd = inject(SessionEndService);

  start(): void {
    this.zone.runOutsideAngular(() => {
      setInterval(() => {
        const cookies = document.cookie.split(';').map(c => c.trim());
        if (cookies.some(c => c.startsWith('logoutEvent='))) {
          this.zone.run(() => this.sessionEnd.endByOtherApp());
        }
      }, 3000);
    });
  }
}
